import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { isValidEntityUser } from '@/utils/user';
import { sortObjectArray } from '@/utils/array';
import { SORT_DIRECTION } from '@/types/ordering';
import { userDetailsAtom } from './queries/user';
import { rawDefaultTeamGamesAtom } from './queries/teams';

export const hasVideoLicenceAtom = atom(async get => {
  const user = await get(userDetailsAtom);

  return user.data?.features?.video;
});

export const isValidEntityUserAtom = atom(async get => {
  const { data } = await get(userDetailsAtom);
  return isValidEntityUser(data);
});

const defaultTeamMostRecentGameIdAtom = atom(async get => {
  const defaultTeamGames = await get(rawDefaultTeamGamesAtom);
  if (!defaultTeamGames.data || !defaultTeamGames.data.length) {
    return null;
  }

  const sortedDefaultTeamGameId = sortObjectArray('game.date', defaultTeamGames.data, 'en', SORT_DIRECTION.DESC);
  return sortedDefaultTeamGameId[0].game.game_id;
});

export const unwrappedDefaultTeamMostRecentGameIdAtom = unwrap(
  defaultTeamMostRecentGameIdAtom,
  prev => prev || undefined,
);
